import { useState, useRef, useCallback, useEffect } from "react";
import { select as d3Select } from 'd3-selection';
import useFirstRender from "./useFirstRender";
// Constants
import * as constants from './constants';

const useAnimated = ({
  attrs,
  duration,
  ease,
  deps,
  on_start,
  on_stop,
  run_on_first_render = false
}) => {
  // Local state
  const [local_attrs, _update_attrs] = useState(attrs);
  // Create ref
  let ref = useRef();
  // Establish whether it's the first render
  const first_render = useFirstRender();

  // Animation function
  const execute_transition = useCallback(() => {
    if (!ref.current) return;
    if (first_render && !run_on_first_render) return;

    if (duration === 0) {
      _update_attrs(attrs);
      return;
    }

    // Do animation
    const element = d3Select(ref.current);
    const transition = element.transition().duration(duration);
    for (let attr in attrs) {
      transition.attr(attr, attrs[attr]);
    }
    if (ease) {
      transition.ease(ease);
    } else {
      transition.ease(constants.DEFAULT_EASE)
    }
    on_start?.();

    // After transition ended, update local state to final values
    transition.on('end', () => {
      if (!ref.current) return;
      _update_attrs(attrs);
      on_stop?.();
    });

    // Cleanup by ending transitions
    return () => {
      element.interrupt();
      on_stop?.();
    }
  }, deps);

  // Run execute_transition when deps change
  useEffect(execute_transition, deps);

  return [ref, local_attrs];
}

export default useAnimated;
